document.querySelectorAll('form[novalidate]').forEach((form) => {
    form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();

            form.classList.add('was-validated');

            const firstInvalid = form.querySelector(':invalid');

             if (firstInvalid) {

                firstInvalid.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });

                setTimeout(() => {
                    firstInvalid.focus({
                        preventScroll: true
                    });
                }, 300);
            }

            return;
        }

        form.classList.add('was-validated');
    });
});